import './more-page.scss';
import React, { useEffect, useState } from 'react';
import { getProgramMorePages } from '../../shared/services/more-page/more-page-service';
import Loading from '../../components/loading/item-loading/loading';
import ListView from '../../components/list-view/live-view';
import { Button } from '@material-ui/core';
import { setTitle } from '../../shared/services/general/general-service';
import { useConfigApp } from '../../shared/services/general/app-context';
import { useLocation } from 'react-router-dom';
import SkeletonLoader from '../../components/skeleton-loader/skeleton-loader';

function ProgramMorePage(props) {
	const [data, setData] = useState([]);
	const [page, setPage] = useState(0);
	const [showLoadMore, setShowLoadMore] = useState(false);
	const [loading, setLoading] = useState(true);
	const configApp = useConfigApp();
	const location = useLocation();
	const path = location.pathname;
	useEffect(() => {
		if (path.includes('/category/')) {
			const  id = path.split('/category/')[1].split('/')[0];
			setTitle(`${getValueById(id, 'catList')} | ${configApp?.title}`);
		} else if (path.includes('/genre/')) {
			const id = path.split('/genre/')[1].split('/')[0];
			setTitle(`${getValueById(id, 'genreList')} | ${configApp?.title}`);
		} else if (path.includes('/p/movies')) {
			const id = path.split('/p/movies/')[1].split('/')[0];
			setTitle(`${getValueById(id, 'catList')} | ${configApp?.title}`);
		} else if (path.includes('/p/SERIES')) {
			const id = path.split('/p/SERIES/')[1].split('/')[0];
			setTitle(`${getValueById(id, 'catList')} | ${configApp?.title}`);
		} else {
			setTitle(`${configApp?.title}`);
		}
		getProgramMorePages(props.match.params.type, props.match.params.id, page, props.match.params.option).then(
			(res) => {
				const newData = res.data.data;
				setShowLoadMore(newData.length >= 199);
				setData((prevData) => [...prevData, ...newData]);
				setLoading(false)
			}
		);
	}, [path, page]);

	const getValueById = (id, source = 'catList') => {
		const storedList = JSON.parse(localStorage.getItem(source)) || [];
		const targetItem = storedList.find(item => item.id === id);
		return targetItem ? targetItem.value : null;
	}

	if (loading) {
		return (
			<>
				<div className="program-skeletonLoader">
					<div className="d-flex"
						 style={{ gap: '20px' }}>
						<SkeletonLoader type="text" count={1} width={'70px'} height={'12px'} />
						<SkeletonLoader type="text" count={1} width={'70px'} height={'12px'} />
						<SkeletonLoader type="text" count={1} width={'70px'} height={'12px'} />
					</div>
					<div style={{ marginBottom: '30px' }}>
						<SkeletonLoader type="text" count={1} width={'150px'} height={'18px'} />
					</div>
				</div>
				<SkeletonLoader type="items" count={35} />
			</>
		)

	} else if (data.length === 0) {
		return (
			<>
				<p style={{ color: 'white', fontSize: '16px', textAlign: 'center', marginTop: '100px' }}>
					متاسفانه محتوایی برای نمایش وجود ندارد
				</p>
			</>
		);
	}

	return (
		<div className="list-view-container">
			<ListView
				data={data}
				type={props.match.params.type} />
			{showLoadMore ?
				<Button
					hidden={page === 0 && loading}
					disabled={loading}
					onClick={() => { setPage(page + 1); }}
					variant={'contained'}
					className="load-more">
					<span>موارد بیشتر</span>
				</Button> : null}
		</div>
	);
}

export default ProgramMorePage;
